import React from 'react';
import { X } from 'lucide-react';

interface InjectsSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
}

export function InjectsSidebar({ isOpen, onClose, title, children }: InjectsSidebarProps) {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity duration-200"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="fixed right-0 top-0 bottom-0 w-full sm:w-96 bg-card border-l border-border shadow-lg z-50 flex flex-col overflow-hidden transition-transform duration-200">
        <div className="flex items-center justify-between border-b border-border p-4 flex-shrink-0">
          {title && <h2 className="font-semibold text-card-foreground truncate">{title}</h2>}
          <button
            type="button"
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-colors"
            aria-label="Close sidebar"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
      </div>
    </>
  );
}
